import React, { useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useAddress } from '../contexts/AddressContext';
import AddressSetupGPS from './address/AddressSetupGPS';
import AddressSetupManual from './address/AddressSetupManual';

const AddressSetupPage: React.FC = () => {
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const [searchParams] = useSearchParams();
  const { address, getSelectedMethod } = useAddress();
  
  // URL에서 선택된 방법 가져오기
  const currentMethod = searchParams.get('method') as 'gps' | 'manual' | null;
  
  // 저장된 방법 가져오기
  const savedMethod = getSelectedMethod();

  // URL에 방법이 없고 주소도 설정되지 않은 경우 방법 선택 페이지로 리다이렉트
  useEffect(() => {
    const hasAddress = address && address.isComplete;
    const hasStay = address?.stay;
    
    // 리다이렉트 조건을 더 명확하게 정의
    // 1. 주소가 없고
    // 2. URL에 method 파라미터가 없고  
    // 3. Stay 정보도 없는 경우에만 리다이렉트
    const shouldRedirect = !hasAddress && !currentMethod && !hasStay;
    
    if (shouldRedirect) {
      navigate(
        { pathname: "/address/method", search: routerLocation.search },
        { replace: true }
      );
      return;
    } 
  }, [address, currentMethod, navigate, routerLocation.search]);

  // 방법에 따라 적절한 컴포넌트 렌더링
  // 우선순위: URL method > 저장된 method > 기본값(manual)
  const effectiveMethod = currentMethod || savedMethod || 'manual';
  
  
  if (effectiveMethod === 'gps') {
    return <AddressSetupGPS />;
  } else {
    return <AddressSetupManual />;
  }
};

export default AddressSetupPage; 